import {
  OneClick2,
  OuterLayoutLogo,
  Paymob,
  Store,
  SignUP,
  CustomerService,
  OneClickOuterWeb,
} from 'apps/customer/src/assets/icons';
import { FeatureCard } from './FeatureCard';
import { DeviceContext } from 'apps/customer/src/context/device';
import { ReactNode, useContext } from 'react';

type OuterLayoutProps = {
  children: ReactNode;
};
const OuterLayout = ({ children }: OuterLayoutProps) => {
  const { isMobile } = useContext(DeviceContext);
  return (
    <div className="md:flex md:flex-row-reverse">
      <div className="md:h-screen md:w-1/2 md:px-20 md:flex md:flex-col md:justify-center md:items-center">
        {isMobile && <div className="pt-5 ps-5">{OneClick2}</div>}
        {!isMobile && <div className="w-full pt-5">{OneClickOuterWeb}</div>}
        {children}
      </div>
      <main className="relative overflow-hidden md:flex md:h-screen md:w-1/2">
        {!isMobile && (
          <div className="absolute left-[5.2%] top-[15.6%]">
            {OuterLayoutLogo}
          </div>
        )}
        <div
          className="md:flex md:flex-col md:justify-between md:w-full md:h-full"
          style={{
            background: 'linear-gradient(180deg, #01AEE6 0%, #223C85 100%)',
          }}
        >
          <div className="hidden md:block md:pl-16 md:pt-5">{Paymob}</div>

          <div className="md:flex-1 md:flex md:justify-center md:items-center">
            <div className="flex flex-col gap-6 md:gap-10 items-start pt-[46px] px-[21px] md:px-20 pb-[125px] md:justify-center md:items-center text-white">
              <div className="flex flex-col self-stretch gap-4">
                <h3 className="english-heading-montserrat-medium ">
                  Why to start using{' '}
                  <span className="english-heading-montserrat-bold">
                    Click ?
                  </span>
                </h3>
                <p className="english-body-montserrat-normal md:hidden">
                  Begin your journey today with Paymob
                </p>
              </div>

              <div>
                <FeatureCard
                  icon={SignUP}
                  title="Securely store your cards"
                  description="Save your cards and addresses safely for a faster, hassle-free checkout with Paymob merchants"
                />
                <FeatureCard
                  icon={CustomerService}
                  title="Encrypted and secure data"
                  description="Encrypting your information with PCI-compliant security, ensuring retailers never have access to it."
                />
                <FeatureCard
                  icon={Store}
                  title="All in one with Click portal"
                  description="Control your cards, addresses, passkeys, and transactions—all in one place with Click Portal."
                />
              </div>
            </div>
          </div>

          <div className="hidden md:block md:text-white md:english-body-montserrat-normal-small md:pb-7 md:pl-16">
            Paymob © 2023. All rights reserved.
          </div>
        </div>
      </main>
    </div>
  );
};

export default OuterLayout;
